import React from "react";
import UserManagementTabs from "../UserManagementTabs";
import PendingApprovals from "./view";

const PendingApprovalsPage = () => {
  return (
    <UserManagementTabs
      showHeader={true}
      title="Pending New Users"
      subtitle="Users who have signed up and are waiting for admin approval"
    >
      <PendingApprovals />
    </UserManagementTabs>
  );
};

export default PendingApprovalsPage;
